import { facetAdaptor } from '@seo/facet-adapter';
import { FacetData } from '../../../../../types/facets';

const facetDataAdapter = (mappedBloomreachResponse: Record<string, any> = {}): FacetData => {
  const emptyFacetData = {
    appliedFacets: {},
    facetOptions: []
  };

  return Object.keys(mappedBloomreachResponse).length > 0
    ? facetAdaptor(mappedBloomreachResponse)
    : emptyFacetData;
};

export default facetDataAdapter;
